import { useState } from "react";
import { TextField, InputAdornment, IconButton, Autocomplete } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TextFieldProps } from "@mui/material";

type StyledTextFieldProps = {
    factor?: number;
    appTheme?: any;
} & TextFieldProps;

export const StyledTextboxInput = ({factor, appTheme, ...textFieldProps }: StyledTextFieldProps) => {

    factor = factor ? factor : 1;

    if (factor === undefined) {
        factor = 1;
    }
  
    return  (
        <TextField
            {...textFieldProps}
            sx={{
              padding: 0,
              
              "& .MuiInputBase-input": { fontSize: 12 * (factor ? factor : 1), height: 12 * (factor ? factor : 1), padding: 1 },
              '& .MuiOutlinedInput-root': { padding: '5px 10px' },
              '& input': { textAlign: 'left', lineHeight: 'normal' },
            }}
            InputLabelProps={{
                sx: { fontSize: 14 * (factor ? factor : 1), lineHeight: 'normal', padding: '0px 10px', backgroundColor: 'white', marginTop: '0px' },
                shrink: true
            }}
            InputProps={{
                sx: {
                    height: 45*factor,
                    fontSize: 12 * (factor ? factor : 1),
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: appTheme.palette.primary.main,
                    },
                },
            }}
          />
        )
}